import { isDebug, isMobileApp, PddPayloadTypes } from "@/constants";
import { Context } from "@/context";
import { lazy, Suspense, useContext, useEffect, useState } from "react";
import { OffscreenCanvas } from "./components/OffscreenCanvas";
import { WorkerStats } from "./components/WorkerStats";
import { usePhysicsListeners } from "./hooks/usePhysicsListeners";
import { useRenderedListeners } from "./hooks/useRenderedListeners";

const Canvas = lazy(() =>
  import("@react-three/fiber").then((module) => ({ default: module.Canvas })),
);
const RenderedScene = lazy(() =>
  import("@/components/RenderedScene").then((module) => ({
    default: module.RenderedScene,
  })),
);

export const DiceCanvases = () => {
  const { physicsWorker, renderedWorker, renderedWorkerPort } =
    useContext(Context);
  const [isDiceStoreEmpty, setIsDiceStoreEmpty] = useState(true);

  usePhysicsListeners(setIsDiceStoreEmpty);
  useRenderedListeners();

  useEffect(() => {
    if (!(physicsWorker && renderedWorker)) return;

    const handleResize = () => {
      if (isDiceStoreEmpty) return;

      physicsWorker.postMessage({
        type: PddPayloadTypes.ResetStore,
      });
      renderedWorker.postMessage({
        type: PddPayloadTypes.ResetStore,
      });
      setIsDiceStoreEmpty(true);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isDiceStoreEmpty, physicsWorker, renderedWorker]);

  if (!(physicsWorker && (isMobileApp ? renderedWorkerPort : renderedWorker)))
    return;

  return (
    <>
      <OffscreenCanvas
        worker={physicsWorker}
        dpr={1}
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 999999999,
          pointerEvents: "none",
        }}
      />
      {isMobileApp ? (
        <Suspense>
          <Canvas
            dpr={1}
            frameloop="demand"
            shadows
            style={{
              position: "fixed",
              inset: 0,
              zIndex: 99999999,
              pointerEvents: "none",
            }}
          >
            <RenderedScene port={renderedWorkerPort} />
          </Canvas>
        </Suspense>
      ) : (
        <OffscreenCanvas
          worker={renderedWorker!}
          dpr={1}
          frameloop="demand"
          shadows
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 99999999,
            pointerEvents: "none",
          }}
        />
      )}
      {isDebug && <WorkerStats />}
    </>
  );
};
